import API from '../../constants/api';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import { catchError } from '../reducers/commonReducer';
import errorChecker from './errorChecker';
import { setDelivery } from '../reducers/basketReducer';

export const sendOrder = val => async dispatch =>
  fetch(API.mainAPI + API.newOrder, {
    method: 'post',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(val),
  })
    .then(errorChecker)
    .then(data => data)
    .catch(err => {
      dispatch(catchError(err));
      console.log(err);
      return err;
    });

export const checkOrder = orderID => async dispatch =>
  fetch(`${API.mainAPI + API.pictToOrder}${orderID}/finalize/`, {
    method: 'post',
  })
    .then(errorChecker)
    .then(data => data)
    .catch(err => {
      dispatch(catchError(err));
      console.log(err);
      return err;
    });

export const takeLink = orderID => async dispatch =>
  fetch(`${API.mainAPI + API.pictToOrder}${orderID}/pay/`, {
    method: 'post',
  })
    .then(errorChecker)
    .then(data => data)
    .catch(err => {
      dispatch(catchError(err));
      console.log(err);
      return err;
    });

export const checkPromocode = val => async dispatch =>
  fetch(API.mainAPI + API.orderPrice, {
    method: 'post',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(val),
  })
    .then(errorChecker)
    .then(data => data)
    .catch(err => {
      dispatch(catchError(err));
      console.log(err);
      return err;
    });

export const checkPromocodeSeparatly = val => async dispatch =>
  fetch(`${API.mainAPI + API.checkPromoCodeSeparatly + val}/`, {
    method: 'GET',
  })
    .then(errorChecker)
    .then(data => data)
    .catch(err => {
      dispatch(catchError(err));
      console.log(err);
      return err;
    });

export const getDelivery = () => dispatch =>
  fetch(API.mainAPI + API.deliveryPathPrices)
    .then(errorChecker)
    .then(data => dispatch(setDelivery(data)))
    .catch(err => console.log(err));
